// extracted by mini-css-extract-plugin
export default {"main-section":"AddParametersFilePage_main-section__xXvyQ"};